import { createBoundaryFunction } from './internals';
import { untrackStart, untrackEnd } from './reaction';
export var untracked = createBoundaryFunction(untrackStart, untrackEnd);
//# sourceMappingURL=untracked.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/reactive-vue/node_modules/@formily/reactive/esm/untracked.js
// module id = null
// module chunks = 